import React from 'react'
import {connect} from 'react-redux'

import config from '../../config.js'

import 'Skelet/src/start.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.

import {toggleDropdown} from 'Skelet/src/modules/functions.js'
import CompanyFooter from 'Skelet/src/components/Company_Footer.js';
import StartFooter from 'Skelet/src/components/Start_Footer.js'


class StartRoute extends React.Component {

  constructor(props) {
    super(props);

    this.state = {is_scrolling:false};
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(e) {
    if(window.pageYOffset === 0) {
      this.setState({is_scrolling:false});
    } else if(!this.state.is_scrolling) {
      this.setState({is_scrolling:true});
    }
  }

  render() {
    const Header = () => <header className="scrolling" style={{display:(this.state.is_scrolling) ? "block" : "none"}}><div className="container wrap wrap-full">
      <div className="primary">
        <a href="/#start" onClick={() => document.getElementById("main").scrollIntoView(true)} className="logo text">Peter van der Meer</a>
      </div>
      <div className="secondary">
            <nav className="navigation">
              <ol>
                <li className="md-shown nav-item"><a href="/#start" onClick={() => document.getElementById("main").scrollIntoView(true)} className="btn btn-offset btn-fat">Start</a></li>
                <li className="md-shown nav-item"><a href="/website-fixer" className="btn btn-offset btn-fat">Website Fixer</a></li>
                <li className="md-shown nav-item"><a href="/websites" className="btn btn-offset btn-fat">Websites</a></li>
                <li className="md-shown nav-item"><a href="/marketing" className="btn btn-offset btn-fat">Marketing</a></li>
                <li className="md-shown nav-item"><a href="/contact" className="btn btn-offset btn-fat btn-if btn-if-fill-blue">Contact</a></li>
                <li className={"md-hidden nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                  <a href="/start" onClick={(e) => toggleDropdown(this, e)}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{height:"32px"}}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg></a>
                  <div className="dropdown-menu">
                    <div className="dropdown-caret">
                      <span className="caret-outer"></span>
                      <span className="caret-inner"></span>
                    </div>
                    <ul style={{textAlign:"center"}}>
                      <li className="nav-item"><a href="/#start" onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);}} className="btn btn-offset btn-fat">Start</a></li>
                      <li className="nav-item"><a href="/website-fixer" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Website Fixer</a></li>
                      <li className="nav-item"><a href="/websites" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Websites</a></li>
                      <li className="nav-item"><a href="/marketing" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Marketing</a></li>
                      <li className="nav-item"><a href="/contact" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat btn-if btn-if-fill-blue">Contact</a></li>
                    </ul>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
    </div></header>;

    const HeaderLanding = () => <header className="scrolling" style={{display:(this.state.is_scrolling) ? "block" : "none"}}><div className="container wrap wrap-full">
      <div className="primary">
        <a href={this.props.pathname+"#start"} onClick={() => document.getElementById("main").scrollIntoView(true)} className="logo text">Peter van der Meer</a>
      </div>
      <div className="secondary">
            <nav className="navigation">
              <ol>
                <li className="md-shown nav-item"><a href="/contact" className="btn btn-offset btn-fat btn-if btn-if-fill-blue">Contact</a></li>
                <li className={"md-hidden nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                  <a href="/start" onClick={(e) => toggleDropdown(this, e)}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{height:"32px"}}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg></a>
                  <div className="dropdown-menu">
                    <div className="dropdown-caret">
                      <span className="caret-outer"></span>
                      <span className="caret-inner"></span>
                    </div>
                    <ul style={{textAlign:"center"}}>
                      <li className="nav-item"><a href="/contact" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat btn-if btn-if-fill-blue">Contact</a></li>
                    </ul>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
    </div></header>;

    /*const HeaderCheck = () => <header className="scrolling" style={{display:(this.state.is_scrolling) ? "none" : "block", background:"#f2aa22", textAlign:"center", fontSize:"120%", padding:"7px 0"}}>
        De <a href="/#check" style={{color:"#000", textDecoration:"underline"}}>Mini Marketing Check</a> (gratis)! <a href="https://www.linkedin.com/in/peterdotplus/" target="blank" style={{color:"#000", textDecoration:"underline"}}>Stuur mij direct</a> jouw pagina of website!
      </header>;*/

      const HeaderWebsiteFixer = () => <header className="scrolling" style={{display:(this.state.is_scrolling) ? "none" : "block", background:"#f2aa22", textAlign:"center", fontSize:"120%", padding:"7px 0"}}>
          Tijdelijke actie: <a href="/website-fixer" style={{color:"#000", textDecoration:"underline"}}>Website-probleem? Laat het oplossen</a> door een zeer ervaren programmeur! (Meeste klussen 75-250 totaal)
        </header>;

    return (
      <div>
        <div className="start">
          <main>
            {this.props.pathname !== "/fitness" && <Header />}
            {this.props.pathname === "/fitness" && <HeaderLanding />}
            {/*<HeaderCheck />*/}
            <HeaderWebsiteFixer />
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              config,
              session_token: this.props.session_token
            })}
            {/*this.props.children && React.cloneElement(this.props.children, {
              openModal: this.openModal
            })*/}
          </main>
          <CompanyFooter site="INFLOW" sitemap={{"Start":"/", "Website Fixer":"/website-fixer", "Websites":"/websites", "Marketing":"/marketing", "Contact":"/contact"}} />
          <StartFooter />
        </div>
      </div>
    );
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    pathname: ownProps.location.pathname
  }
}

export default connect(mapStateToProps, null)(StartRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/StartRoute.js